module.exports = __webpack_public_path__ + "84dde0e9b64ed2b5463161aeb937c6b9.pdf";